import { render, staticRenderFns } from "./PosSales.vue?vue&type=template&id=ba0142b0&scoped=true"
import script from "./PosSales.vue?vue&type=script&lang=js"
export * from "./PosSales.vue?vue&type=script&lang=js"
import style0 from "./PosSales.vue?vue&type=style&index=0&id=ba0142b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0142b0",
  null
  
)

export default component.exports